import { gql } from 'graphql-tag';
export const USER_DEEP_FRAGMENT = gql `
  fragment UserDeepFragment on User {
    __typename
    id
    isAdmin
    settings {
      theme
    }
  }
`;
export const USER_GET = gql `
  ${USER_DEEP_FRAGMENT}
  query UserGet {
    user: User {
      ...UserDeepFragment
    }

    entitlements(perPage: 10000) {
      id
      identifier
    }
  }
`;
export const USER_UPDATE = gql `
  ${USER_DEEP_FRAGMENT}
  mutation UserUpdate($user: UpdateUserDto!) {
    user: updateUser(user: $user) {
      ...UserDeepFragment
    }
  }
`;
//# sourceMappingURL=user.js.map